<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <button class="btn-back" @click="votar">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                        </svg>
                                        Voltar
                                    </button>
                                    <h1 class="modern-title">Fornecedores</h1>
                                    <p class="modern-subtitle">Fornecedores cadastrados para este produto ou serviço</p>
                                </div>
                                <div class="header-actions">
                                    <button class="modern-btn modern-btn-success" @click="gerarExcel">
                                        Exportar Excel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="page-container" v-if="fornecedor">

                    <!-- Identity card -->
                    <div class="det-identity-card" :class="fornecedor.IdCatMat != 0 ? 'det-identity-card--produto' : 'det-identity-card--servico'">
                        <div class="det-identity-card__icon">
                            <i :class="fornecedor.IdCatMat != 0 ? 'fas fa-box' : 'fas fa-wrench'"></i>
                            <span class="det-identity-card__icon-label">
                                {{ fornecedor.IdCatMat != 0 ? 'Produto' : 'Serviço' }}
                            </span>
                        </div>
                        <div class="det-identity-card__content">
                            <div class="det-identity-card__header">
                                <span class="det-identity-card__label">
                                    {{ fornecedor.IdCatMat != 0 ? 'Produto' : 'Serviço' }}
                                </span>
                                <span class="det-count-badge" :class="fornecedor.IdCatMat != 0 ? 'det-count-badge--teal' : 'det-count-badge--gold'">
                                    <i class="fas fa-building"></i>
                                    {{ fornecedor.countItens }} {{ fornecedor.countItens === 1 ? 'fornecedor' : 'fornecedores' }}
                                </span>
                            </div>
                            <h2 class="det-identity-card__razao">{{ fornecedor.descricao }}</h2>
                        </div>
                    </div>

                    <!-- Filter panel -->
                    <div class="det-filter-panel">
                        <div class="det-filter-panel__title">
                            <i class="fas fa-filter"></i>
                            Filtrar fornecedores
                        </div>

                        <div class="det-filter-grid">
                            <div class="det-filter-group">
                                <label class="det-filter-label">Pesquisar</label>
                                <input class="det-filter-input"
                                       type="text"
                                       placeholder="Nome, razão social…"
                                       maxlength="50"
                                       v-model="pesquisaDetalhes.termoPesquisa"
                                       @keydown.enter="search" />
                            </div>

                            <div class="det-filter-group">
                                <label class="det-filter-label">Estado (UF)</label>
                                <select class="det-filter-select" v-model="pesquisaDetalhes.nmEstado">
                                    <option value="">Selecione</option>
                                    <option :value="item" v-for="(item, index) in lstEstados" :key="index">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>

                            <div class="det-filter-group">
                                <label class="det-filter-label">Cidade</label>
                                <input class="det-filter-input"
                                       type="text"
                                       placeholder="Nome da cidade"
                                       maxlength="50"
                                       v-model="pesquisaDetalhes.nmCidade"
                                       @keydown.enter="search" />
                            </div>

                            <div class="det-filter-group det-filter-group--btn">
                                <button class="det-btn-buscar" @click="search">
                                    <i class="fas fa-search"></i>
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Results table -->
                    <div class="det-table-wrap">
                        <Grid url_ajax="/Fornecedor/Detalhes"
                              :is_table="false"
                              :reload="reload"
                              :ajax_set_result="setFornecedores"
                              :data_ajax="getDataAjax()"
                              :ajax_set_count="setCount">
                            <template #rows="{ rows }">

                                <div v-if="rows.length === 0 && flResultados" class="det-no-results">
                                    <i class="fas fa-search det-no-results__icon"></i>
                                    <p class="det-no-results__text">Nenhum fornecedor encontrado para os filtros aplicados.</p>
                                </div>

                                <div v-else class="det-table-container">
                                    <table class="det-table">
                                        <thead class="det-table__head">
                                            <tr>
                                                <th>Razão Social / CNPJ</th>
                                                <th>Cidade / UF</th>
                                                <th>Contato</th>
                                                <th class="det-table__th-center">Penalidades</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="det-table__row"
                                                v-for="(row, index) in rows"
                                                :key="index"
                                                :style="{ animationDelay: `${index * 30}ms` }">

                                                <td class="det-table__td">
                                                    <span class="det-table__razao">{{ row.razaoSocial }}</span>
                                                    <span class="det-table__cnpj">{{ row.cnpj }}</span>
                                                </td>

                                                <td class="det-table__td">
                                                    <span class="det-table__cidade">{{ row.cidade }}</span>
                                                    <span class="det-table__uf-chip">{{ row.estado }}</span>
                                                </td>

                                                <td class="det-table__td">
                                                    <a v-if="row.email || row.Email"
                                                       :href="'mailto:' + (row.email || row.Email)"
                                                       class="det-table__email">
                                                        <i class="fas fa-envelope"></i>
                                                        {{ row.email || row.Email }}
                                                    </a>
                                                    <span v-if="row.telefone" class="det-table__telefone">
                                                        <i class="fas fa-phone"></i>
                                                        {{ row.telefone }}
                                                    </span>
                                                </td>

                                                <td class="det-table__td det-table__td--center">
                                                    <span class="det-penalty-badge det-penalty-badge--ok" v-if="!row.temPenalidade">
                                                        <i class="fas fa-thumbs-up"></i>
                                                        Sem penalidade
                                                    </span>
                                                    <span class="det-penalty-badge det-penalty-badge--warn" v-else>
                                                        <i class="fas fa-thumbs-down"></i>
                                                        Com penalidade
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </template>
                        </Grid>
                    </div>

                </div>

                </div>
            </div>
        </div>
        <Modais></Modais>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import Grid from '@/components/Ferramentas/Grid'
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default defineComponent({
        name: 'DetalheFornecedor',
        components: { Header, Grid, Modais },

        data() {
            return {
                pesquisaDetalhes: {
                    nmCidade: '',
                    termoPesquisa: '',
                    nmEstado: '',
                },

                fornecedor: history.state.fornecedor ?? null,
                pesquisa: history.state.pesquisa ?? {},
                idPesquisaFornecedor: history.state.idPesquisaFornecedor ?? null,

                lstEstados: [
                    'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO',
                    'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
                    'RJ', 'RN', 'RO', 'RS', 'RR', 'SC', 'SE', 'SP', 'TO',
                ],

                reload: 0,
                lstResultados: [],
                flResultados: false,
            }
        },

        computed: {
            user() { return this.$store.state.user },
        },

        methods: {
            votar() { this.$router.go(-1) },

            load() {
                if (!this.fornecedor) {
                    this.$router.push({ name: 'Fornecedores' })
                    return
                }
                this.pesquisaDetalhes = {
                    nmCidade: '',
                    termoPesquisa: '',
                    nmEstado: this.pesquisa?.nmEstado || '',
                }
                this.reload += 1
            },

            search() { this.reload += 1 },

            setFornecedores(rows) {
                const lista = rows?.fornecedores || []
                this.lstResultados = lista
                this.flResultados = true
                return this.lstResultados
            },

            getDataAjax() {
                return {
                    idCatalogo: this.fornecedor?.idCatMat != 0
                        ? this.fornecedor?.idCatMat
                        : this.fornecedor?.idCatSer,
                    dsPesquisa: this.pesquisaDetalhes.termoPesquisa,
                    nmCidade: this.pesquisaDetalhes.nmCidade,
                    nmEstado: this.pesquisaDetalhes.nmEstado,
                    chkProduto: this.pesquisa?.chkProduto,
                    chkServico: this.pesquisa?.chkServico,
                    idPesquisaFornecedor: this.idPesquisaFornecedor,
                    idCatMat: this.fornecedor?.idCatMat,
                    idCatSer: this.fornecedor?.idCatSer,
                }
            },

            setCount(res) { return res?.data?.itensCount },

            async gerarExcel() {
                try {
                    const response = await axios({
                        url: `${urlApi}/Fornecedor/GerarExcel/`,
                        method: 'GET',
                        responseType: 'blob',
                        params: this.getDataAjax(),
                    })
                    const href = URL.createObjectURL(response.data)
                    const link = document.createElement('a')
                    link.href = href
                    link.setAttribute('download', 'documento.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    URL.revokeObjectURL(href)
                } catch (res) {
                    avisoErro(res?.response?.data || res?.response?.statusText || 'Erro ao gerar Excel')
                }
            },
        },

        mounted() { this.load() },
    })
</script>

<style lang="scss" scoped>
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .btn-back {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: none;
        color: #6b7280;
        font-size: 13px;
        font-weight: 600;
        padding: 0;
        margin-bottom: 4px;
        cursor: pointer;
        width: fit-content;
    }

    .btn-back:hover {
        color: #2563eb;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        min-height: 42px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
    }

    .page-container {
        --dark: #1f2937;
        --gold: #2563eb;
        --gold-light: #3b82f6;
        --warm-white: #ffffff;
        --bg: #f8fafc;
        --border: #e5e7eb;
        --muted: #6b7280;
        --teal: #2563eb;
        --teal-dark: #1d4ed8;
        --teal-soft: rgba(37, 99, 235, .1);
        --ink: #1f2937;
        --success: #16a34a;
        --success-sf: rgba(22, 163, 74, .1);
        --danger: #dc2626;
        --danger-sf: rgba(220, 38, 38, .1);
        max-width: 1140px;
        margin: 0 auto;
        padding: 24px 16px 48px;
    }

    /* ── IDENTITY CARD ───────────────────────────── */
    .det-identity-card {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 4px 24px rgba(0,0,0,.09);
        overflow: hidden;
        display: grid;
        grid-template-columns: 120px 1fr;
        margin-bottom: 24px;
        border: 1px solid var(--border);

        &--produto .det-identity-card__icon {
            background: var(--teal);
        }

        &--servico .det-identity-card__icon {
            background: var(--gold);
        }
    }

    .det-identity-card__icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 24px 16px;

        i {
            color: #fff;
            font-size: 32px;
        }
    }

    .det-identity-card__icon-label {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .1em;
        text-transform: uppercase;
        color: rgba(255,255,255,.85);
    }

    .det-identity-card__content {
        padding: 22px 28px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 10px;
    }

    .det-identity-card__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .det-identity-card__label {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .12em;
        text-transform: uppercase;
        color: var(--muted);
    }

    .det-count-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .06em;
        text-transform: uppercase;
        padding: 4px 14px;
        border-radius: 20px;

        &--teal {
            background: var(--teal-soft);
            color: var(--teal-dark);
        }

        &--gold {
            background: rgba(200,146,42,.1);
            color: var(--gold);
        }
    }

    .det-identity-card__razao {
        font-size: 20px;
        font-weight: 800;
        color: var(--dark);
        margin: 0;
        line-height: 1.3;
        letter-spacing: -0.3px;
    }

    /* ── FILTER PANEL ────────────────────────────── */
    .det-filter-panel {
        background: #fff;
        border-radius: 10px;
        border: 1px solid var(--border);
        box-shadow: 0 2px 10px rgba(0,0,0,.05);
        padding: 20px 24px 24px;
        margin-bottom: 24px;
        border-top: 4px solid #2563eb;
    }

    .det-filter-panel__title {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .08em;
        text-transform: uppercase;
        color: var(--muted);
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;

        i {
            color: var(--teal);
        }
    }

    .det-filter-grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr auto;
        gap: 16px;
        align-items: end;
    }

    .det-filter-group {
        display: flex;
        flex-direction: column;
        gap: 6px;

        &--btn {
            justify-content: flex-end;
        }
    }

    .det-filter-label {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .08em;
        text-transform: uppercase;
        color: var(--muted);
    }

    .det-filter-input,
    .det-filter-select {
        height: 42px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        padding: 0 14px;
        font-size: 14px;
        color: var(--ink);
        background: #fff;
        outline: none;
        transition: border-color .2s, box-shadow .2s;
        appearance: none;

        &:focus {
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }

        &::placeholder {
            color: #9ca3af;
        }
    }

    .det-filter-select {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%236b7280' d='M6 8L0 0h12z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 14px center;
        padding-right: 36px;
        cursor: pointer;
    }

    .det-btn-buscar {
        height: 42px;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        border: none;
        border-radius: 10px;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 0 20px;
        white-space: nowrap;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);

        &:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
            transform: translateY(-2px);
        }
    }

    /* ── TABLE ───────────────────────────────────── */
    .det-table-wrap {
        background: #fff;
        border-radius: 10px;
        border: 1px solid var(--border);
        box-shadow: 0 2px 10px rgba(0,0,0,.05);
        overflow: hidden;
    }

    .det-table-container {
        overflow-x: auto;
    }

    .det-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }

    .det-table__head tr {
        background: var(--bg);
        border-bottom: 2px solid var(--border);
    }

    .det-table__head th {
        padding: 13px 18px;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: .08em;
        text-transform: uppercase;
        color: var(--muted);
        text-align: left;
        white-space: nowrap;
    }

    /* Larguras relativas das colunas para melhorar o contato no responsivo */
    .det-table__head th:nth-child(1),
    .det-table__td:nth-child(1) {
        min-width: 220px;
    }

    .det-table__head th:nth-child(2),
    .det-table__td:nth-child(2) {
        min-width: 150px;
    }

    .det-table__head th:nth-child(3),
    .det-table__td:nth-child(3) {
        min-width: 260px;
    }

    .det-table__th-center {
        text-align: center !important;
    }

    .det-table__row {
        border-bottom: 1px solid #f0ede8;
        animation: rowIn .3s ease both;
        transition: background .15s;

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            background: #fafaf8;
        }
    }

    .det-table__td {
        padding: 14px 18px;
        vertical-align: middle;

        &--center {
            text-align: center;
        }
    }

    .det-table__razao {
        display: block;
        font-weight: 700;
        color: var(--dark);
        font-size: 13px;
        line-height: 1.35;
    }

    .det-table__cnpj {
        display: block;
        font-size: 12px;
        color: var(--muted);
        margin-top: 2px;
        font-family: 'Courier New', monospace;
    }

    .det-table__cidade {
        font-size: 13px;
        font-weight: 600;
        color: var(--ink);
    }

    .det-table__uf-chip {
        display: inline-block;
        margin-left: 6px;
        background: var(--bg);
        border: 1px solid var(--border);
        border-radius: 4px;
        padding: 1px 7px;
        font-size: 11px;
        font-weight: 700;
        color: var(--muted);
    }

    .det-table__email {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: var(--teal-dark);
        text-decoration: none;
        word-break: break-all;

        i {
            flex-shrink: 0;
            font-size: 11px;
        }

        &:hover {
            text-decoration: underline;
        }
    }

    .det-table__telefone {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: var(--muted);
        margin-top: 4px;

        i {
            flex-shrink: 0;
            font-size: 11px;
        }
    }

    /* Penalty badges */
    .det-penalty-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .05em;
        text-transform: uppercase;
        padding: 5px 12px;
        border-radius: 20px;
        white-space: nowrap;

        &--ok {
            background: var(--success-sf);
            color: var(--success);
            border: 1px solid rgba(22,163,74,.2);
        }

        &--warn {
            background: var(--danger-sf);
            color: var(--danger);
            border: 1px solid rgba(220,38,38,.2);
        }
    }

    /* No results */
    .det-no-results {
        padding: 48px 32px;
        text-align: center;
    }

    .det-no-results__icon {
        font-size: 28px;
        color: var(--border);
        margin-bottom: 12px;
        display: block;
    }

    .det-no-results__text {
        font-size: 15px;
        color: var(--muted);
        margin: 0;
    }

    /* Grid pagination override */
    :deep(.grid-app .btn-navegacao) {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
        border: none !important;
        border-radius: 10px !important;
        font-weight: 600;
        padding: 8px 16px;
        color: #fff !important;
    }

    @keyframes rowIn {
        from {
            opacity: 0;
            transform: translateX(-4px);
        }

        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    /* ── RESPONSIVE ──────────────────────────────── */
    @media (max-width: 991px) {
        .det-filter-grid {
            grid-template-columns: 1fr 1fr;
        }

        .det-filter-group--btn {
            grid-column: span 2;
        }

        .det-btn-buscar {
            width: 100%;
        }
    }

    /* Paginação mais compacta no mobile: só ícones, botões menores lado a lado */
    @media (max-width: 576px) {
        :deep(.grid-app .btn-navegacao) {
            padding: 6px 8px !important;
            border-radius: 4px !important;
            min-width: 32px;
            height: 32px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }

        :deep(.grid-app .btn-navegacao i) {
            font-size: 14px !important;
            margin: 0 !important;
        }

        /* Esconde apenas o texto/label, preservando o ícone */
        :deep(.grid-app .btn-navegacao span),
        :deep(.grid-app .btn-navegacao strong),
        :deep(.grid-app .btn-navegacao small) {
            display: none !important;
        }

        :deep(.grid-app .paginacao) {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            justify-content: center;
        }
    }

    @media (max-width: 768px) {
        .modern-title {
            font-size: 24px;
        }

        .header-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .det-identity-card {
            grid-template-columns: 90px 1fr;
        }

        .det-filter-grid {
            grid-template-columns: 1fr;
        }

        .det-filter-group--btn {
            grid-column: span 1;
        }
    }

    @media print {
        .btn-back, .modern-btn {
            display: none !important;
        }
    }
</style>